import { render } from "./SmallKeyboardComponent.vue?vue&type=template&id=6279dd0a"
import script from "./SmallKeyboardComponent.vue?vue&type=script&lang=js"
export * from "./SmallKeyboardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__